import { Liquid } from 'liquidjs';
var engine = new Liquid();
export default function parseLiquidTemplate() {
  var html = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var templateParsed = engine.parseAndRenderSync(html, context);
  return templateParsed;
}